import { Paragraph, VStack, VstackProps } from '@styled-system/jsx';

type Props = {
  count: number;
  label: string;
} & VstackProps;

export const Stats = ({ count, label, ...vstackProps }: Props) => {
  return (
    <VStack
      justifyContent="center"
      alignItems="center"
      gap="4px"
      minWidth="70px"
      padding="10px"
      {...vstackProps}
    >
      <Paragraph
        textAlign="center"
        fontSize="size_16"
        fontWeight={600}
        color="accent.1000"
      >
        {count.toLocaleString()}
      </Paragraph>
      <Paragraph textAlign="center" fontSize="size_10" color="accent.500">
        {label}
      </Paragraph>
    </VStack>
  );
};
